// extracted by mini-css-extract-plugin
export default {"addClassContainer":"AddStudents_addClassContainer__OBwUm","closeButton":"AddStudents_closeButton__vSggJ","fadeIn":"AddStudents_fadeIn__4Gs4F","fadeOut":"AddStudents_fadeOut__h+T+m"};